import { DARK_CHANNEL_SPEND_SHARE_PCT } from '../../dtc-commerce-mmm-constants';

export const AttributionMetric = {
  CONTRIBUTION: 'contribution',
  SPEND: 'spend'
} as const;
export type AttributionMetricType = (typeof AttributionMetric)[keyof typeof AttributionMetric];

// Matches TwoStageDecompEntry.categoryType: demand generation picks up credit ('added') from
// demand capture, which hands it over ('reduced').
export const FlowDirection = {
  ADDED: 'added',
  REDUCED: 'reduced'
} as const;
export type FlowDirectionType = (typeof FlowDirection)[keyof typeof FlowDirection];

export const FlowStepKind = {
  DIRECT: 'direct',
  PARTNER: 'partner',
  OTHERS: 'others',
  ACTUALIZED: 'actualized'
} as const;
export type FlowStepKindType = (typeof FlowStepKind)[keyof typeof FlowStepKind];

// Partners worth less than this share of the feature's direct total fold into one "other channels"
// step — the same 1% cutoff the page uses for dark channels.
export const SMALL_PARTNER_SHARE_OF_DIRECT = DARK_CHANNEL_SPEND_SHARE_PCT / 100;

// Folding a lone small partner would only rename it.
export const MIN_PARTNERS_TO_FOLD = 2;
